import axios from 'axios';

import { ChatMessageAction } from '../../entities/chat-message-action';
import { auth } from '../firebase/firebase';
import { API_BASE_URL } from './index';

export interface ChatSession {
  _id: string;
  projectId: string;
  userId: string;
  title?: string;
  createdAt: number;
  updatedAt: number;
}

export interface ChatSessionMessage {
  sender: string;
  text: string;
  isUser: boolean;
  hidden?: boolean;
  createdAt: number;
  actions?: ChatMessageAction[]; // present only on agent replies that offer a CTA, e.g. "Connect Jira"
}

const getHeaders = async () => {
  const idToken = await auth.currentUser?.getIdToken();
  return { Authorization: `Bearer ${idToken}` };
};

export const getProjectSessions = async (projectId: string): Promise<ChatSession[]> => {
  const headers = await getHeaders();
  const { data } = await axios.get<ChatSession[]>(`${API_BASE_URL}/api/chat/sessions`, {
    params: { projectId },
    headers,
  });
  return data;
};

export const createSession = async (projectId: string, title?: string): Promise<ChatSession> => {
  const headers = await getHeaders();
  const { data } = await axios.post<ChatSession>(
    `${API_BASE_URL}/api/chat/sessions`,
    { projectId, title: title ?? `Session ${new Date().toLocaleDateString()}` },
    { headers },
  );
  return data;
};

export const getSessionMessages = async (sessionId: string): Promise<ChatSessionMessage[]> => {
  const headers = await getHeaders();
  const { data } = await axios.get<ChatSessionMessage[]>(`${API_BASE_URL}/api/chat/sessions/${sessionId}/messages`, {
    headers,
  });
  return data;
};
